import React from "react";
import { useQuery } from "react-query";
import { getInvoiceAutoPay } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

const useGetInvoiceAutoPay = () => {
  return useQuery("GetInvoiceAutoPay", getInvoiceAutoPay, {
    refetchOnWindowFocus: false,
  });
};

export default useGetInvoiceAutoPay;
